import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import {EmptyObservable} from "rxjs/observable/EmptyObservable";
import { throttleTime } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})


export class ClientService {
  constructor(private http: HttpClient) {}

  getClientsList(): Observable<any[]> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const options = {
      httpOptions,
      params: {}
    };
    
    return this.http.get<any[]>(`${environment.apiUrl}/api/clients`, options);
  }

  getClientPlans(): Observable<any[]> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const options = {
      httpOptions,
      params: {}
    };

    return this.http.get<any[]>(
      `${environment.apiUrl}/api/client/passesAvailable`,
      options
    );
  }

  create(data): Observable<any[]> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const options = {
      httpOptions,
      params: {}
    };

    return this.http.post<any[]>(
      `${environment.apiUrl}/api/client/addNew`,
      data,
      options
    );
  }

  getPassAutocomplete(): Observable<any[]> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const options = {
      httpOptions,
      params: {}
    };

    return this.http.get<any[]>(
      `${environment.apiUrl}/api/passAutocomplete`,
      options
    );
  }

  issetClient(id: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const options = {
      httpOptions,
      params: {}
    };

    return this.http
      .get<any[]>(`${environment.apiUrl}/api/client/${id}`, options)
      .pipe(map(data => (data ? data : 'Nothing found')));
  }



  addSimpleVisitor(comment: string): Observable<any> {
    console.log('addSimpleVisitor run1', comment);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    console.log('addSimpleVisitor run2', comment);

    const options = {
      httpOptions,
      params: {}
    };
    console.log('addSimpleVisitor run3', comment);

    return this.http.post<any[]>(
      `${environment.apiUrl}/api/client/simpleVisitor`,
      { comment: comment },
      options
    ).pipe(map(data => (data ? data : 'Nothing found')));;
  }


  getClient(id: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const options = {
      httpOptions,
      params: {}
    };

    return this.http
      .get<any[]>(`${environment.apiUrl}/api/client/${id}`, options)
      .pipe(
        map(data =>
          data
            ? Object.keys(data).map(i => {
                return {
                  key: i,
                  value: data[i]
                };
              })
            : 'Nothing found'
        )
      );
  }

  getClientCurrentType(id: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const options = {
      httpOptions,
      params: {}
    };

    return this.http
      .get<any[]>(`${environment.apiUrl}/api/client/${id}/currentType`, options)
      .pipe(
        map(
          data =>
            data &&
            Object.keys(data).map(i => {
              return {
                key: i,
                value: data[i]
              };
            })
        )
      );
  }

  getCurrentStats() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const options = {
      httpOptions,
      params: {}
    };
    console.log('getCurrentStats called');
    return this.http.get<any[]>(
      `${environment.apiUrl}/api/stats`,
      options
    );
  }

  // getClientsList(): Observable<any[]> {
  //   const httpOptions = {
  //     headers: new HttpHeaders({
  //       'Content-Type': 'application/json'
  //     })
  //   };
  //   const options = {
  //     httpOptions,
  //     params: {}
  //   };

  //   return this.http.get<any[]>(`${environment.apiUrl}/api/clients`, options);
  // }

  getAllVisits(from: string = '', to: string = ''): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const options = {
      httpOptions,
      params: {}
    };
    console.log('getAllVisits called', from, to );
    return this.http.get<any[]>(
      `${environment.apiUrl}/api/visits?from=${from}&to=${to}`,
      options
    );
  }

  getAllFirstTimers(from: string = '', to: string = ''): Observable<number> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const options = {
      httpOptions,
      params: {}
    };
    console.log('getAllFirstTimers called', from, to );
    return this.http.get<number>(
      `${environment.apiUrl}/api/firstTimers?from=${from}&to=${to}`,
      options
    );
  }

  getAllNewClients(from: string = '', to: string = ''): Observable<number> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const options = {
      httpOptions,
      params: {}
    };
    console.log('getAllNewClients called', from, to );
    return this.http.get<number>(
      `${environment.apiUrl}/api/newClients?from=${from}&to=${to}`,
      options
    );
  }

  // getFirstTimersHistoryObservable(id, from: string='', to: string=''): Observable<any[]> {
  //   const httpOptions = {
  //     headers: new HttpHeaders({
  //       'Content-Type': 'application/json'
  //     })
  //   };
  //   const options = {
  //     httpOptions,
  //     params: {}
  //   };
  //   console.log('getAllVisits called', from, to );
  //   //      `${environment.apiUrl}/api/client/${id}/visitsHistory`,

  //   return this.http.get<any[]>(
  //     `${environment.apiUrl}/api/client/${id}/firstTimers?from=${from}&to=${to}`,
  //     options
  //   );
  // }

  // getNewClientsHistoryObservable(id, from: string='', to: string=''): Observable<any[]> {
  //   const httpOptions = {
  //     headers: new HttpHeaders({
  //       'Content-Type': 'application/json'
  //     })
  //   };
  //   const options = {
  //     httpOptions,
  //     params: {}
  //   };
  //   console.log('getNewClientsHistoryObservable called', from, to );
  //   //      `${environment.apiUrl}/api/client/${id}/visitsHistory`,

  //   return this.http.get<any[]>(
  //     `${environment.apiUrl}/api/client/${id}/newClients?from=${from}&to=${to}`,
  //     options
  //   );
  // }

  getClientVisitsHistoryObservable(id, from: string='', to: string=''): Observable<any[]> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const options = {
      httpOptions,
      params: {}
    };

    return this.http.get<any[]>(
      `${environment.apiUrl}/api/client/${id}/visitsHistory?from=${from}&to=${to}`,
      options
    );
  }

  getClientVisitsHistory(id: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const options = {
      httpOptions,
      params: {}
    };

    return this.http.get<any[]>(
      `${environment.apiUrl}/api/client/${id}/visitsHistory`,
      options
    );
  }

  getClientPlansHistory(id: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const options = {
      httpOptions,
      params: {}
    };

    return this.http.get<any[]>(
      `${environment.apiUrl}/api/client/${id}/plansHistory`,
      options
    );
  }

  getClientBalanceHistory(id: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const options = {
      httpOptions,
      params: {}
    };

    return this.http.get<any[]>(
      `${environment.apiUrl}/api/client/${id}/balanceHistory`,
      options
    );
  }

  searchPasses(pass: string): Observable<any[]>{
    if (pass.length < 2) return new EmptyObservable<Response[]>();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const options = {
      httpOptions,
      params: {}
    };

    return this.http.get<any[]>(
      `${environment.apiUrl}/api/searchPasses/${pass}`,
      options
    )
  }

  getStats(): Observable<any> {
    return combineLatest(this.getCurrentStats()).pipe(
      map(([stats])=>{return {stats}}))
  }

  getClientData(id: string): Observable<any> {
    return combineLatest(
      this.getClient(id),
      this.getClientCurrentType(id),
      this.getClientVisitsHistory(id),
      this.getClientPlansHistory(id),
      this.getClientBalanceHistory(id),
      this.getCurrentStats(),
      this.getClientPlans()
    ).pipe(
      map(
        ([
          info,
          currentType,
          visitsHistory,
          plansHistory,
          balanceHistory,
          currentStats,
          plans
        ]) => {
          return {
            info,
            currentType,
            visitsHistory,
            plansHistory,
            balanceHistory,
            currentStats, 
            plans: Object.keys(plans).map(i => {
              return {
                key: i,
                value: plans[i]
              };
            })
          };
        }
      )
    );
  }

  updateClientBalance(id: string, data: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const options = {
      httpOptions,
      params: {}
    };

    return this.http.post<any[]>(
      `${environment.apiUrl}/api/client/${id}/changeBalance`,
      { balance: data.balance, comment: data.comment },
      options
    );
  }

  updateClientVisit(id: string, data: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const options = {
      httpOptions,
      params: {}
    };

    return this.http.post<any[]>(
      `${environment.apiUrl}/api/client/${id}/addVisit`,
      { comment: data.comment },
      options
    );
  }

  updateClientPlan(id: string, plan: string, comment: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const options = {
      httpOptions,
      params: {}
    };

    return this.http.post<any[]>(
      `${environment.apiUrl}/api/client/${id}/newState/${plan}`,
      { comment: comment },
      options
    );
  }
}
